import { render, staticRenderFns } from "./AllocationOfResourcesTable.vue?vue&type=template&id=18d16e59&scoped=true"
import script from "./AllocationOfResourcesTable.vue?vue&type=script&lang=js"
export * from "./AllocationOfResourcesTable.vue?vue&type=script&lang=js"
import style0 from "./AllocationOfResourcesTable.vue?vue&type=style&index=0&id=18d16e59&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d16e59",
  null
  
)

export default component.exports